import { useState } from 'react';
import Calendar from 'react-calendar';
import moment from 'moment';
import styled from 'styled-components';
import calendarIcon from '../../images/common/calendar-icon-purple.svg';

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 12px;
`;

const TriggerButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid ${({ active }) => (active ? '#714fff' : '#e5e7eb')};
  background: #ffffff;
  color: ${({ active }) => (active ? '#714fff' : '#0f0b28')};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
`;

const CalendarDropdown = styled.div`
  position: absolute;
  right: 30px;
  top: 130px;
  max-width: 280px;
  margin-bottom: 12px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  padding: 8px;

  .react-calendar {
    border: none;
    width: 100%;
    font-size: 12px;
  }
  .react-calendar__tile--active {
    background: #ede8ff !important;
    border-radius: 0;
    color: black !important;
  }

  .react-calendar__tile--rangeStart,
  .react-calendar__tile--rangeEnd {
    background: #714fff !important;
    color: white !important;
  }
  .react-calendar__tile--rangeStart {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  .react-calendar__tile--rangeEnd {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;

const DateRangePicker = ({
  value,
  onChange,
  placeholder = 'Select custom range',
}) => {
  const [showCalendar, setShowCalendar] = useState(false);

  const hasRange = value?.from && value?.to;
  const label = hasRange
    ? `${moment(value.from).format('DD')} - ${moment(value.to).format('DD MMM YYYY')}`
    : placeholder;

  const handleChange = (range) => {
    if (!Array.isArray(range) || range.length !== 2) return;
    const [from, to] = range;
    setShowCalendar(false);
    onChange({ from, to });
  };

  return (
    <Wrapper>
      <TriggerButton
        active={hasRange}
        onClick={() => setShowCalendar((v) => !v)}
      >
        <span>{label}</span>
        <img src={calendarIcon} alt="" width={20} height={20} />
      </TriggerButton>
      {showCalendar && (
        <CalendarDropdown>
          <Calendar
            selectRange
            onChange={handleChange}
            value={hasRange ? [value.from, value.to] : null}
            next2Label={null}
            prev2Label={null}
            calendarType="US"
          />
        </CalendarDropdown>
      )}
    </Wrapper>
  );
};

export default DateRangePicker;
